import { Controller } from '@hotwired/stimulus'
import {
  SAVE_AND_CONTINUE_CHANGE_HEADING,
  SAVE_AND_CONTINUE_NO_LONGER_ALLOWED,
  SAVE_AND_CONTINUE_WILL_BE_ALLOWED,
  trans,
} from '../translator'

export default class SaveAndContinuePreviewController extends Controller<HTMLElement> {
  static targets = ['enabled', 'consequence', 'save']
  static values = { enabled: Boolean }

  declare readonly enabledTarget: HTMLInputElement
  declare readonly consequenceTarget: HTMLElement
  declare readonly hasConsequenceTarget: boolean
  declare readonly saveTarget: HTMLButtonElement
  declare readonly hasSaveTarget: boolean
  declare readonly enabledValue: boolean

  private readonly onChange = (): void => this.refresh()

  connect (): void {
    this.element.addEventListener('change', this.onChange)
    this.refresh()
  }

  disconnect (): void {
    this.element.removeEventListener('change', this.onChange)
  }

  refresh (): void {
    const enabled = this.enabledTarget.checked
    const changed = enabled !== this.enabledValue

    this.render(enabled, changed)

    if (this.hasSaveTarget) {
      this.saveTarget.disabled = !changed
    }
  }

  private render (enabled: boolean, changed: boolean): void {
    if (!this.hasConsequenceTarget) {
      return
    }

    this.consequenceTarget.textContent = ''

    if (!changed) {
      return
    }

    const heading = document.createElement('p')
    heading.textContent = trans(SAVE_AND_CONTINUE_CHANGE_HEADING, {}, 'form-types')

    const point = document.createElement('li')
    point.textContent = trans(enabled ? SAVE_AND_CONTINUE_WILL_BE_ALLOWED : SAVE_AND_CONTINUE_NO_LONGER_ALLOWED, {}, 'form-types')

    const points = document.createElement('ul')
    points.appendChild(point)

    this.consequenceTarget.appendChild(heading)
    this.consequenceTarget.appendChild(points)
  }
}
